<template>
    <div>
        <div class="banner"></div>
        <div class="content">
            <div class="contentCom">
                <el-row>
                    <el-col :span="5">
                        <div class="title">
                            企业概况 <br/>
                            <span style="font-size:16px;">
                                Company Profile
                            </span>
                        </div>
                        <div class="menu">
                            <div class="qygkContent">
                                <div v-for="(item,index) in menuList" :key="item.url" @click="tab(item,$event)" class="name" :class="{'active':item.active}">
                                    {{item.name}}
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="18" :offset="1">
                        <div class="nrTitle">
                            {{titleName}}
                        </div>
                        <div class="nrWord" v-if="page === '21'">
                            <p>
                                连云港格润环保科技有限公司（以下简称“格润环保”）成立于2020年4月，总部位于中国首批沿海开放城市、新亚欧大陆桥经济走廊首个节点城市-连云港市，公司现有灌云、海州两处办公地点。公司是一家崇尚创新、追求极致、满怀理想、奋发拼搏的环保咨询公司，格润环保是由江苏省环保系统资深专家、具有丰富市场人脉资源行业领军人等多人初创，致力于打造全国环境咨询行业连云港样板为落脚点，尽己所能为打赢“美丽中国”保卫战，在推动环保管家管理、环境咨询和“三废”污染防治中展现企业的探索和担当。
                            </p>
                            <p>
                                年轻、活力、实干使我们团队的代名词。做事高效、团结互助、说话直接是我们团队的行为风格，我们拒绝非实干分子。在这里，有轻松活跃的工作氛围；有快速的成长空间；有诱人的薪酬收入；有不断完善的福利；有更大的能力施展舞台。在这里，我们是共同创业的战友。
                            </p>
                            <p>
                                秉承技术团队在环保服务市场的深厚积累，格润环保有一支技术过硬的环保管家式技术顾问团队，目前公司现有各类市场、技术人员近30人，均在环保咨询行业工作多年，拥有丰富的环保工作经验，以高起点致力于为各级政府部门、企事业单位提供全方位、专业化、系统性、持续性的环保管家一站式服务。服务范围包括环境影响评价，环保规划，污染场地调查评估与修复，环境损害鉴定评估，泄漏检测与修复（LDAR），环境监理，可行性研究报告，环境污染防治工程的设计，环保验收，清洁生产，环保顾问等技术服务及咨询。
                            </p>
                        </div>
                        <div v-if="page === '22'">
                            <div class="yyzz">
                                <img width="100%" src="../assets/images/yyzz.jpg" alt="">
                            </div>
                        </div>
                        <div v-if="page === '23'">
                            <img src="../assets/images/ywfw.jpg" alt="">
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            page:'21',
            titleName:'企业简介',
            menuList:[
                {
                    name:'企业简介',
                    url:'21',
                    active:true,
                },{
                    name:'单位资质',
                    url:'22',
                    active:false,
                },{
                    name:'业务范围',
                    active:false,
                    url:'23'
                }
            ],
        }
    },
    mounted() {
        if (this.$route.query) {
            if (this.$route.query.page) {
                this.page = this.$route.query.page
            }
            this.menuList.forEach(val => {
                val.active = false
                if (val.url == this.page) {
                    val.active = true
                    this.titleName = val.name
                }
            });
        }
    },
    methods: {
        tab(item,e){
            this.menuList.forEach(val => {
                val.active = false
            });
            this.titleName = item.name
            this.page = item.url
            item.active = true
            this.$router.push({
                path:'/profile',
                query:{
                    page:item.url,
                },
            })
        },
    },
}
</script>

<style scoped>
    .banner {
        width: 1400px;
        margin: 0 auto;
        background: url(../assets/images/banner.jpg);
        height: 306px;
    }
     @media screen and (max-width: 1366px){
        .banner {
            width: 100%;
        }
    }
    .content {
        margin-top: 20px;
    }
    .contentCom {
        margin: 20px auto 50px;
        width: 1200px;
    }
    .title{
        background: #49A8F8;
        color: white;
        font-size: 20px;
        width: 100%;
        text-align: center;
        padding: 30px 0 20px;
    }
    .menu{
        width: 100%;
        text-align: center;
        font-size: 16px;
    }
    .qygkContent{
        background: #49A8F8;
        width: 100%;
        border-top: 1px dashed white;
        padding-bottom: 20px;
    }
    .name{
        width: 80%;
        margin: 0 auto;
        color: white;
        padding: 15px 0;
        border-bottom: 1px dashed white;
        cursor: pointer;
    }
    .name.active{
        color: #49A8F8;
        width: 100%;
        background: #eff7ff;
    }
    .nrTitle{
        width: 100%;
        font-size: 20px;
        color: #323232;
        padding:10px 0;
        border-bottom: 1px solid #aeaeae;
        font-weight: bold;
    }
    .nrWord{
        text-align: justify;
        text-indent: 30px;
        color: #323232;
        font-size: 15px;
        line-height: 2.5;
        padding-top: 20px;
    }
    .nrWord p{
        margin: 0;
    }
    .yyzz {
        width: 100%;
    }
</style>